module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v("联系方式")]), _vm._v(" "), _c('el-form', [_c('div', {
    staticClass: "container"
  }, [_c('el-form-item', {
    attrs: {
      "label": "手机"
    }
  }, [_c('el-input', {
    attrs: {
      "value": _vm.contact.phone,
      "placeholder": "请填写手机号码"
    },
    on: {
      "change": function($event) {
        _vm.changeEditor({
          $event: $event,
          a: 'contact',
          b: 'phone'
        })
      }
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "微信"
    }
  }, [_c('el-input', {
    attrs: {
      "value": _vm.contact.wechat,
      "placeholder": "请填写微信号"
    },
    on: {
      "change": function($event) {
        _vm.changeEditor({
          $event: $event,
          a: 'contact',
          b: 'wechat'
        })
      }
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "邮箱"
    }
  }, [_c('el-input', {
    attrs: {
      "value": _vm.contact.email,
      "placeholder": "请填写电子邮箱"
    },
    on: {
      "change": function($event) {
        _vm.changeEditor({
          $event: $event,
          a: 'contact',
          b: 'email'
        })
      }
    }
  })], 1)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-506f896c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/editor/ContactEditor.vue
// module id = 198
// module chunks = 1